import ReactGA from 'react-ga4'
// Initialize Google Analytics
export const initGA = () => {
  // Initialize with your Google Analytics measurement ID
  ReactGA.initialize('G-VTJBSB463X')
  console.log('Google Analytics initialized')
}
// Track page views
export const trackPageView = (path: string) => {
  ReactGA.send({ hitType: 'pageview', page: path })
  console.log(`Page view tracked: ${path}`)
}
// Track events
export const trackEvent = (
  category: string,
  action: string,
  label?: string,
  value?: number,
) => {
  ReactGA.event({
    category,
    action,
    label,
    value,
  })
  console.log(
    `Event tracked: ${category} - ${action} ${label ? `- ${label}` : ''}`,
  )
}
